/**
 * События сессии, которыми обмениваются вкладки кабинета одного браузера:
 * `logout` — сессия сброшена (выход, истечение, бездействие), `login` — сотрудник вошёл.
 */
export type TSessionMessage = { type: 'logout' } | { type: 'login' };

const CHANNEL_NAME = 'mfo-main-session';

/** Канал между вкладками; в окружении без `BroadcastChannel` вкладки не синхронизируются. */
const channel =
  typeof BroadcastChannel === 'undefined'
    ? null
    : new BroadcastChannel(CHANNEL_NAME);

const isSessionMessage = (value: unknown): value is TSessionMessage =>
  typeof value === 'object' &&
  value !== null &&
  ((value as TSessionMessage).type === 'logout' ||
    (value as TSessionMessage).type === 'login');

/** Сообщает остальным вкладкам о событии сессии. Своя вкладка его не получает. */
export const postSessionMessage = (message: TSessionMessage): void => {
  channel?.postMessage(message);
};

/**
 * Подписка на события сессии из других вкладок. Сообщения чужого формата
 * пропускаются. Возвращает отписку.
 */
export const subscribeSessionMessages = (
  handler: (message: TSessionMessage) => void
): (() => void) => {
  if (!channel) return () => undefined;

  const listener = ({ data }: MessageEvent): void => {
    if (isSessionMessage(data)) handler(data);
  };
  channel.addEventListener('message', listener);
  return () => channel.removeEventListener('message', listener);
};
